(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_blog_faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const questions = document.querySelectorAll(".faq-question");
    questions.forEach((btn) => {
      btn.addEventListener("click", function () {
        const currentAnswer = this.nextElementSibling;
        document.querySelectorAll(".faq-answer").forEach((answer) => {
          if (answer !== currentAnswer) {
            answer.classList.remove("open");
            answer.style.maxHeight = null;
          }
        });
        if (currentAnswer.classList.contains("open")) {
          currentAnswer.classList.remove("open");
          currentAnswer.style.maxHeight = null;
        } else {
          currentAnswer.classList.add("open");
          currentAnswer.style.maxHeight = currentAnswer.scrollHeight + "px";
        }
      });
      const index = btn.dataset.index;
      if (index === "0") {
        const answer = btn.nextElementSibling;
        answer.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_collection_faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const questions = document.querySelectorAll(".faq-question");

    questions.forEach((btn) => {
      btn.addEventListener("click", function () {
        const currentAnswer = this.nextElementSibling;

        // Alle Antworten schließen
        document.querySelectorAll(".faq-answer").forEach((answer) => {
          if (answer !== currentAnswer) {
            answer.classList.remove("open");
            answer.style.maxHeight = null;
          }
        });

        // Aktuelle Antwort ein- oder ausklappen
        if (currentAnswer.classList.contains("open")) {
          currentAnswer.classList.remove("open");
          currentAnswer.style.maxHeight = null;
        } else {
          currentAnswer.classList.add("open");
          currentAnswer.style.maxHeight = currentAnswer.scrollHeight + "px";
        }
      });

      // Erste Antwort beim Laden geöffnet lassen
      const index = btn.dataset.index;
      if (index === "0") {
        const answer = btn.nextElementSibling;
        answer.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_collection_grid"] && !Shopify.designMode) return;
  try {
    
(function($){
  // Sidebar accordion: nur den Toggle-Link abfangen, nicht die Child-Links blocken
  $(document).on("click", ".with_sub > a.hassub_after", function(e){
    e.preventDefault(); // nur für den Toggle-Link
    var $li = $(this).closest(".with_sub");
    $li.toggleClass("open_sidebar");
    $li.children(".child").slideToggle(150);
  });

  // Child-Links sollen normal navigieren; nur Bubbling stoppen, damit oben nichts greift
  $(document).on("click", ".with_sub .child a", function(e){
    e.stopPropagation();
    // kein preventDefault -> Link funktioniert
  });

  $(document).ready(function(){
    // Aktiven Link markieren
    $(".sidebar-nav-box ul li ul li a").each(function(){
      if($(this).attr("href")==window.location.pathname){
        $(this).addClass("active_sidebarmenu");
      }
    });
    // Offene Eltern automatisch aufklappen
    $(".with_sub").each(function(){
      if ($(this).find(".active_sidebarmenu").length > 0){
        $(this).addClass("open_sidebar")
               .children(".child").show();
      }
    });
  });

  // "Mehr laden" AJAX
  $(document).on("click", "#load-more", function(){
    var $btn = $(this);
    var nextUrl = $btn.data("next-url");
    if(!nextUrl) return;

    $btn.prop("disabled", true).text("Laden...");

    fetch(nextUrl, { credentials: 'same-origin' })
      .then(function(res){ return res.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        var newProducts = doc.querySelectorAll("#product-grid .custom_collection_product");
        var grid = document.querySelector("#product-grid");

        newProducts.forEach(function(card){
          grid.appendChild(card);
        });

        // Nachgeladene Karten ebenfalls gegen den Zeitraum prüfen (siehe cc_script.js)
        if (typeof window.syncDiscountBadges === "function") window.syncDiscountBadges();
        // ... und die Reviews.io-Sterne nachziehen
        if (typeof window.syncCardRatings === "function") window.syncCardRatings();

        var nextBtn = doc.querySelector("#load-more");
        if(nextBtn && nextBtn.getAttribute("data-next-url")){
          $btn.data("next-url", nextBtn.getAttribute("data-next-url"));
          $btn.prop("disabled", false).text("Mehr laden");
        } else {
          $btn.remove();
        }
      })
      .catch(function(){
        $btn.prop("disabled", false).text("Mehr laden");
      });
  });
})(window.GemQuery || jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_product_faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const questions = document.querySelectorAll(".faq-question");

    questions.forEach((btn) => {
      btn.addEventListener("click", function () {
        const currentAnswer = this.nextElementSibling;

        // Alle Antworten schließen
        document.querySelectorAll(".faq-answer").forEach((answer) => {
          if (answer !== currentAnswer) {
            answer.classList.remove("open");
            answer.style.maxHeight = null;
          }
        });

        // Aktuelle Antwort ein- oder ausklappen
        if (currentAnswer.classList.contains("open")) {
          currentAnswer.classList.remove("open");
          currentAnswer.style.maxHeight = null;
        } else {
          currentAnswer.classList.add("open");
          currentAnswer.style.maxHeight = currentAnswer.scrollHeight + "px";
        }
      });

      // Erste Antwort beim Laden geöffnet lassen
      const index = btn.dataset.index;
      if (index === "0") {
        const answer = btn.nextElementSibling;
        answer.classList.add("open");
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_video_section"] && !Shopify.designMode) return;
  try {
    
  const video = document.getElementById('myVideo');
  const soundToggle = document.getElementById('soundToggle');
  const soundIcon = document.getElementById('soundIcon');

  // Autoplay when in viewport
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        video.play();
      } else {
        video.pause();
      }
    });
  }, { threshold: 0.5 });

  observer.observe(video);

  // Sound toggle
  soundToggle.addEventListener('click', () => {
    video.muted = !video.muted;
    soundIcon.src = video.muted
      ? "https://cdn.shopify.com/s/files/1/0566/8608/4119/files/volume-mute.svg?v=1750253885"
      : "https://cdn.shopify.com/s/files/1/0566/8608/4119/files/volume.svg?v=1750253885";
    soundIcon.alt = video.muted ? "Ton aus" : "Ton an";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_week_deal"] && !Shopify.designMode) return;
  try {
    
  function updateCountdown() {
    const now = new Date();
    const nextMonday = new Date();
    
    // Calculate days to next Monday 12 PM
    let daysToAdd = (8 - now.getDay()) % 7;
    if (daysToAdd === 0 && now.getHours() >= 12) {
        daysToAdd = 7;
    }
    nextMonday.setDate(now.getDate() + daysToAdd);
    nextMonday.setHours(12, 0, 0, 0);

    const totalSeconds = (nextMonday - now) / 1000;
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    
    document.getElementById('countdown').innerHTML = 
        `${days}d ${hours}h ${minutes}m ${seconds}s`;
}

setInterval(updateCountdown, 1000);
updateCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
